// src/utils/formValidationRules.jsx
import { REGEX } from "./constants";

export const getFormValidationRules = ({
  params,
  getValues,
  resetVerifyEmployeeId,
  employeeIdVerificationRes,
  existingId,
  clearErrors,
  errors,
}) => ({
  employeeId: {
    required: "Please Enter Employee Id",
    pattern: {
      value: REGEX.ALPHANUMERIC_4_25,
      message:
        "Invalid Pattern(Only Alphanumeric from 4 to 25 characters Allowed)",
    },
    validate: (value) => {
      if (employeeIdVerificationRes && existingId && existingId === value) {
        return "User Already Exist. Please Enter  Different Employee Id";
      }
      resetVerifyEmployeeId();
      return true;
    },
  },
  assignment: { required: "Please Select Assignment" },
  userName: {
    required: "Please Enter User Name",
    pattern: {
      value: REGEX.USERNAME_PATTERN,
      message:
        "Invalid Pattern(Only Alphanumerics and . - Allowed, Max 50 characters)",
    },
  },
  firstName: {
    required: "Please Enter First Name",
    pattern: {
      value: REGEX.NAME_PATTERN,
      message: "Invalid Pattern(Only Alphabets Allowed, Max 50 characters)",
    },
  },
  lastName: {
    required: "Please Enter Last Name",
    pattern: {
      value: REGEX.NAME_PATTERN,
      message: "Invalid Pattern(Only Alphabets Allowed, Max 50 characters)",
    },
  },
  nationality: { required: "Please Enter Nationality" },
  email: {
    required: "Please Enter Email",
    pattern: {
      value: REGEX.EMAIL,
      message: "Invalid Email or too long (max 100 characters)",
    },
  },
  personalEmail: {
    pattern: {
      value: REGEX.EMAIL,
      message: "Invalid Pattern or too long (max 100 characters)",
    },
  },
  accountType: {
    required: "Please Select Account Type",
    validate: (value) => {
      const formValues = getValues();
      if (value === "Internal") {
        if (!formValues.cashCenterId && !formValues.officeId) {
          return "Please Select Cash Center & Office";
        } else if (!formValues.cashCenterId) {
          return "Please Select Cash Center";
        } else if (!formValues.officeId) {
          return "Please Select Office";
        }
        if (errors.cashCenterId) {
          clearErrors("cashCenter");
        }
        return true;
      }
      return true;
    },
  },
  mobileNumber: {
    required: "Please Enter Mobile Number",
    pattern: {
      value: REGEX.MOBILE_NUMBER,
      message:
        "Mobile number must be digits only and contain no spaces(7-15 digits)",
    },
  },
  status: { required: "Please Select Account Status" },
  designation: { required: "Please Select Designation" },
  nationalId: {
    pattern: {
      value: REGEX.ALPHANUMERIC_SPACES_50,
      message: "Invalid Pattern(Only upto 50 Alphanumeric Allowed)",
    },
  },
  cashCenterId: {
    validate: (value) => {
      const formValues = getValues();
      if (formValues.accountType === "Internal" && !value) {
        return "Cash Center Is Required If Account Type Is Internal";
      }
      return true;
    },
  },
  officeId: {
    validate: (value) => {
      const formValues = getValues();
      if (formValues.accountType === "Internal" && !value) {
        return "Office Is Required If Account Type Is Internal";
      }
      if (formValues.cashCenterId && !value) {
        return "Office Is Required If Cash Center Is Selected";
      }
      return true;
    },
  },
  passportNumber: {
    pattern: {
      value: REGEX.ALPHANUMERIC_SPACES_50,
      message:
        "Invalid Pattern. Passport No can have up to 50 alphanumeric characters",
    },
  },
  clientId: {
    validate: (value, formValues) => {
      if (formValues.accountType === "External" && (!value || value === "0")) {
        return "Client Id Is Required If Account Type Is External";
      }
      return true;
    },
  },
  drivingLicenseNo: {
    pattern: {
      value: REGEX.ALPHANUMERIC_50,
      message: "Invalid pattern. Only up to 50 alphanumeric characters allowed",
    },
  },
  cenconId: {
    pattern: {
      value: REGEX.ALPHANUMERIC_50,
      message: "Only upto 50 alphanumeric characters allowed",
    },
  },
  managerId: {
    pattern: {
      value: REGEX.ALPHANUMERIC_50,
      message: "Manager ID cannot exceed 50 alphanumeric characters",
    },
  },
  roles: {
    validate: (value) => {
      if (value.length === 0) {
        return "Please Select Role";
      }
      return true;
    },
  },
});
